// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52f6e44d","455":"46d9dfc7","977":"f2feca1e"}[chunkId] + ".chunk.js";
};